import { TraderDiary, TraderDiaryTableRow } from '../redux/reducers/traderDiary';
import { fetchRequest } from '../services/http.service'

export const GET_TRADER_DIARY_URL = '/traderdiary'
export const UPDATE_TRADER_DIARY_DIARY_URL = 'traderdiary/diary'
export const UPDATE_TRADER_DIARY_EXPORT_URL = 'traderdiary/export'
export const CREATE_MASS_TRADER_DIARY_URL = 'traderdiary/create/mass'
export const UPDATE_TRADER_DIARY_STATE_URL = 'traderdiary/cancel'

export const getTraderDiariesRequest = (dateFrom: string, dateTo: string) =>  fetchRequest.get<TraderDiaryTableRow[]>(GET_TRADER_DIARY_URL+getParams(dateFrom, dateTo));
export const updateOrderDiaryRequest = (traderDiaryId: number, diaryValue: boolean) => fetchRequest.put(UPDATE_TRADER_DIARY_DIARY_URL + `?traderDiaryId=${traderDiaryId}&diaryValue=${diaryValue}`, null)
export const createTraderDiaryMassRequest = (traderDiaries: TraderDiary[]) => fetchRequest.post<TraderDiaryTableRow[]>(CREATE_MASS_TRADER_DIARY_URL, traderDiaries)
export const exportTreaderDiaryRequest = (traderDiaryIds: number[], dateFrom: string, dateTo: string) => fetchRequest.put<any>(UPDATE_TRADER_DIARY_EXPORT_URL + `?dateFrom=${dateFrom}&dateTo=${dateTo}`, {ids: traderDiaryIds})
export const updateTraderDiaryStateRequest = (traderDiaryId: number) => fetchRequest.put(UPDATE_TRADER_DIARY_STATE_URL + `/${traderDiaryId}`, null)

const getParams = (dateFrom: string, dateTo: string) => {
  let tmp = '';
  tmp += dateFrom !== undefined && dateFrom !== null && dateFrom !== ''  ? '?dateFrom='+dateFrom : '';
  if ( tmp === '' ) {
    tmp+='?'
  } else {
    tmp+='&'
  }
  tmp += dateTo !== undefined && dateTo !== null && dateTo !== ''  ? 'dateTo='+dateTo : '';
  return tmp;
}
